import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/utils/shared.service';
import { MasterService } from '../master.service';
import { HttpClient } from '@angular/common/http';
import * as CommonConstants from '../../utils/common.constants';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-sub-speciality',
  templateUrl: './add-sub-speciality.component.html',
  styleUrls: ['./add-sub-speciality.component.scss']
})
export class AddSubSpecialityComponent implements OnInit {

  @Input() partnerId: number;
  @Input() partnerType: number;
  subSpecialityForm: FormGroup;
  specialities: any[];
  subSpecialities: any[];
  subSpecialitiesFiltered: any[];

  submitted = false;
  subSpecList: any[] = [];
  columnDefs:any[];
  toggleDiv = true;

  constructor(private modalService: NgbModal, private formBuilder: FormBuilder,
    private masterService: MasterService, private sharedService: SharedService, private http: HttpClient,
    private toastrService: ToastrService) {
    this.getSubSpecFormGroup();

    this.columnDefs = [
      { headerName: 'Sub Speciality', field: 'ssptyName' },
      { headerName: 'Number Of Beds', field: 'subtyNuNumberBed'},
      { headerName: 'Number Of Specialists', field: 'subtyNuNumberSpecialists' }            
    ]; 
  }

  ngOnInit() {
    this.loadMasterData();
    this.subSpecialityForm.patchValue({
      spltyId: null
    });
  }


  loadMasterData() {
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
    this.masterService.getSubSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.subSpecialities = response['result'];
      }
      })
  }

 subSpecialityAddModal(addSubSpeciality){
    this.modalService.open(addSubSpeciality, { size: 'lg', container: '.page-content' });
  }

  changeSpeciality(obj) {
    this.subSpecialityForm.patchValue({ssptyId:null,hsptyId:null});
    this.subSpecialitiesFiltered = this.subSpecialities.filter(res => {
      return res.spltyId === obj.spltyId
    })
  }

  /**
  * Declare form group
  *  
  */
  private getSubSpecFormGroup() {
    this.subSpecialityForm = this.formBuilder.group({
      'subtyId': new FormControl(),
      'ssptyId': ['', Validators.required],
      'spltyId': new FormControl(),
      'subtyNuNumberBed': new FormControl(),
      'subtyNuNumberSpecialists': new FormControl(),
      'staRecCode':[true]
    })
  }

  /**
   * To get form controls
   */
  get f() { return this.subSpecialityForm.controls; }

  saveSubSpeciality() {
    this.submitted = true;
    if (this.subSpecialityForm.invalid) {
      return;
    }
    let saveData = this.subSpecialityForm.value;
    saveData['partnerId'] = this.partnerId;
    saveData['partnerType'] = this.partnerType;
    saveData["staRecCode"]=this.f.staRecCode.value ? 'A' :'I';
    if (this.subSpecialityForm.value) {
      this.http.post(CommonConstants.SAVE_PARTNER_SUB_SPECIALITY, saveData)
        .subscribe(response => {
          if (response['code'] == 0) {
           
            this.subSpecList = this.sharedService.updateDuplicateRecord(response['subtyId'], this.subSpecList,
              "subtyId", this.subSpecialityForm.value);
              this.subSpecList =this.subSpecList.map(item => ({ ...item, 
                ssptyName: item.ssptyId ? this.subSpecialities.find(obj => +obj.ssptyId === +item.ssptyId).ssptyDescEn: null})); 
            this.modalService.dismissAll("#addSubSpeciality");
          }
        })
    }
  }

  onSubSpecialityRowSelect(spec, addSpec) {
    let data = JSON.parse((JSON.stringify(spec.data)));
    this.modalService.open(addSpec, { size: 'lg', container: '.page-content' });
    this.subSpecialityForm.patchValue([data]);
  }

toggleContent(){
  this.toggleDiv = !this.toggleDiv;
}


}
